import "./LoadingPage.css";

function LoadingPage () {

    return (
        <div className={"loaderContainer"}>
            <div className={"spinner"}></div>
        </div>
    )
}


export default LoadingPage;